import { render } from "./FinishRegister.vue?vue&type=template&id=23f53fb4"
import script from "./FinishRegister.vue?vue&type=script&lang=js"
export * from "./FinishRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__